import { combineReducers } from "redux";
import { SEARCH_FORM, CREATE_ANSWER } from "module/actions";
import { goToError } from "application/functions";
import { requestType, successType, failureType } from "application/reducer/reducer-states";
import formAdapter from "./functions/formAdapter";

const initialState = {
  form: {},
  adaptedForm: {},
  createdAnswerId: {},
  loading: false,
};

export function loading(state = initialState.loading, { type }) {
  switch (type) {
    case successType(CREATE_ANSWER):
      return false;
    case requestType(CREATE_ANSWER):
      return true;
    default:
      return state;
  }
}

export function form(state = initialState.form, { type, payload }) {
  switch (type) {
    case successType(SEARCH_FORM):
      return payload.response.data.form;
    case failureType(SEARCH_FORM):
      goToError();
      return state;
    case requestType(SEARCH_FORM):
    default:
      return state;
  }
}

export function adaptedForm(state = initialState.adaptedForm, { type, payload }) {
  switch (type) {
    case successType(SEARCH_FORM):
      return formAdapter(payload.response.data.form);
    case failureType(SEARCH_FORM):
      goToError();
      return state;
    case requestType(SEARCH_FORM):
    default:
      return state;
  }
}

export function createdAnswerId(state = initialState.createdAnswerId, { type, payload }) {
  switch (type) {
    case successType(CREATE_ANSWER):
      if (payload.response.errors) {
        return { error: true };
      } else {
        return { id: payload.response.data.content.id };
      }
    case failureType(CREATE_ANSWER):
      goToError();
      return state;
    case requestType(CREATE_ANSWER):
    default:
      return state;
  }
}

export default combineReducers({
  loading,
  form,
  adaptedForm,
  createdAnswerId,
});
